export default __webpack_public_path__ + "static/rev-bbbb469fa33debdd4d9d8492bd898d3a.jpeg";